module.exports = "<div class=\"modal-header\">\r\n   <h4 ng-if=\"$ctrl.title\" class=\"modal-title\">{{$ctrl.title}}</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n   <div ng-if=\"$ctrl.message\"\r\n        ng-bind-html=\"$ctrl.message\"></div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n   <rw-button variant=\"contained\"\r\n              action=\"$ctrl.confirm()\">\r\n      <translate>\r\n         OK\r\n      </translate>\r\n   </rw-button>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/views/alert-modal.html
// module id = 540
// module chunks = 0